module.exports = __webpack_public_path__ + "static/img/A56.71ca956a.jpg";